import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helpersNumbers from "../../../../../helpers/numbers";
import TypeGroupSitePublisher from "../../TypeGroupSitePublisher";
import helperSpinner from "../../../../../helpers/spinner";
import Pagination from "../../../../partials/content/Pagination";

function AllGroupUserSitePublisher() {
  const [allGroupUserSitePublisher, setAllGroupUserSitePublisher] = useState(
    []
  );

  const [currentPage, setCurrentPage] = useState(1);
  const [countItemPerPage, setCountItemPerPage] = useState(10);
  const [countPage, setCountPage] = useState(1);
  const [
    groupUserSitePublisherIDSearchFilter,
    setGroupUserSitePublisherIDSearchFilter,
  ] = useState();

  useEffect(() => {
    getAllGroupUserSitePublisher();
  }, []);

  useEffect(() => {
    getAllGroupUserSitePublisher();
  }, [currentPage, countItemPerPage, groupUserSitePublisherIDSearchFilter]);

  const getAllGroupUserSitePublisher = async () => {
    const searchFilterQuery = getSearchFilterQuery();
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    const allGroupUserSitePublisher =
      await sendRequestGetAllGroupUserSitePublisher(searchFilterQuery);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
    if (!allGroupUserSitePublisher) {
      return;
    }
    setAllGroupUserSitePublisher(
      allGroupUserSitePublisher.category_user_site_publishers
    );
    setCountPage(allGroupUserSitePublisher.count_page);
  };

  const paginationItemOnClickHandler = async (e) => {
    if (!e.target.attributes[1]) {
      return;
    }

    setCurrentPage(e.target.attributes[1].value);
  };

  const generatePagination = () => {
    return (
      <div className="py-2 d-flex flex-column flex-md-row  align-items-md-center  ">
        <Pagination
          countPage={countPage}
          currentPage={currentPage}
          paginationItemOnClickHandler={paginationItemOnClickHandler}
        />
      </div>
    );
  };

  const generateAllGroupUserSitePublisher = () => {
    return (
      <>
        <div className="alert alert-info">
          <div className="row pb-2">
            <div className="d-flex align-items-center">
              <div className="pl-2">
                <label>جستجو در شماره گروه نمایش دهنده</label>
              </div>
              <div>
                <input
                  onKeyUp={(e) =>
                    setGroupUserSitePublisherIDSearchFilter(e.target.value)
                  }
                  onWheel={(event) => event.currentTarget.blur()}
                  className="form-control"
                  id="site"
                  type="text"
                />
              </div>
            </div>
          </div>
        </div>
        <div className="table-responsive">
          <table className="table table-hilite tbl-td-white-space">
            <thead>
              <tr>
                <td>#</td>
                <td>شماره گروه</td>
                <td>شماره کاربری</td>
                <td>نام گروه</td>
                <td>نوع گروه</td>
                <td>تاریخ ایجاد</td>
                <td>تاریخ بروزرسانی</td>
                <td>نمایش</td>
              </tr>
            </thead>
            <tbody>
              {allGroupUserSitePublisher.map(
                (groupUserSitePublisher, index) => {
                  let typeGroupSitePublisher =
                    TypeGroupSitePublisher.getTypePersianNameGroupPublisher(
                      groupUserSitePublisher.type
                    );

                  return (
                    <tr key={index}>
                      <td>{helpersNumbers.toPersianNum(index + 1)}</td>
                      <td>
                        {helpersNumbers.toPersianNum(
                          groupUserSitePublisher.cau_id
                        )}
                      </td>
                      <td>
                        {helpersNumbers.toPersianNum(
                          groupUserSitePublisher.cau_user_id
                        )}
                      </td>
                      <td>{groupUserSitePublisher.cau_name}</td>
                      <td>{typeGroupSitePublisher}</td>
                      <td>
                        {helpersNumbers.toPersianNum(
                          groupUserSitePublisher.cau_created_at
                        )}
                      </td>
                      <td>
                        {helpersNumbers.toPersianNum(
                          groupUserSitePublisher.cau_updated_at
                        )}
                      </td>
                      <td>
                        <Link
                          to={`/manage/category-user-site-publishers/${groupUserSitePublisher.cau_id}`}
                          className="btn btn-info"
                        >
                          <i className="fa fa-info"></i>
                        </Link>
                      </td>
                    </tr>
                  );
                }
              )}
            </tbody>
          </table>
        </div>
        {countPage > 1 ? generatePagination() : <></>}
      </>
    );
  };

  const getSearchFilterQuery = () => {
    let searchFilterQuery = "";
    if (groupUserSitePublisherIDSearchFilter) {
      searchFilterQuery = `${searchFilterQuery}&id=${groupUserSitePublisherIDSearchFilter}`;
    }

    return searchFilterQuery;
  };

  const sendRequestGetAllGroupUserSitePublisher = async (searchFilterQuery) => {
    const headersRequest = getHeaderForRequest();
    let groupUserSitePublisher;
    try {
      groupUserSitePublisher = await httpService.getRequest(
        `${process.env.REACT_APP_DOMAIN_API}/v1/manage/category-user-site-publishers/paginate?page=${currentPage}&number=${countItemPerPage}${searchFilterQuery}`,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return groupUserSitePublisher.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  return (
    <>
      <Sidebar
        openItem="manage-category-publisher-menu"
        activeItem="manage-category-user-site-publishers"
      />
      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  نمایش دسته های سایت های نمایش دهنده کاربران
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              {allGroupUserSitePublisher.length == 0 &&
              groupUserSitePublisherIDSearchFilter == null ? (
                <></>
              ) : (
                generateAllGroupUserSitePublisher()
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
export default AllGroupUserSitePublisher;
